import { type ButtonHTMLAttributes, renderSlot } from "vue"
import { defineComponent, optionalProp, type ReactiveComponent, requiredProp, propsWithDefaults } from "vue-utils"

export type BootstrapButtonType = "primary" | "secondary" | "success" | "danger" | "warning" | "info" | "light" | "dark"

export interface Props {
	color: BootstrapButtonType
	plain?: boolean
	isSubmitting?: boolean
}

const BootstrapButton: ReactiveComponent<Props, ButtonHTMLAttributes> = (initialProps, { slots, attrs }) => {
	const props = propsWithDefaults(initialProps, {
		isSubmitting: false,
		plain: false,
	})

	return () => (
		<button
			class={[
				"btn",
				`btn-${props.color}`,
				"flex",
				"justify-center",
				"items-center",
				"spacing-2",
				props.plain && "btn-plain",
			]}
			disabled={(attrs as ButtonHTMLAttributes).disabled || props.isSubmitting}
			{...attrs}
		>
			{props.isSubmitting && <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" />}
			{renderSlot(slots, "default")}
		</button>
	)
}

export default defineComponent(BootstrapButton, {
	color: requiredProp(String),
	plain: optionalProp(Boolean),
	isSubmitting: optionalProp(Boolean),
})
